var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramCertification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16.575V18.6075C10.7453 19.0358 10.6306 19.4557 10.417 19.8269C10.2033 20.1981 9.89792 20.5082 9.53 20.7275C8.74893 21.306 8.11355 22.0587 7.67436 22.9258C7.23516 23.7929 7.00426 24.7505 7 25.7225M15.75 16.575V18.6075C15.7547 19.0358 15.8694 19.4557 16.083 19.8269C16.2967 20.1981 16.6021 20.5082 16.97 20.7275C17.7511 21.306 18.3864 22.0587 18.8256 22.9258C19.2648 23.7929 19.4957 24.7505 19.5 25.7225M20.75 9.5H22.625C23.4538 9.5 24.2487 9.17076 24.8347 8.58471C25.4208 7.99866 25.75 7.2038 25.75 6.375C25.75 5.5462 25.4208 4.75134 24.8347 4.16529C24.2487 3.57924 23.4538 3.25 22.625 3.25H20.75M20.75 9.5C20.75 11.4891 19.9598 13.3968 18.5533 14.8033C17.1468 16.2098 15.2391 17 13.25 17C11.2609 17 9.35322 16.2098 7.9467 14.8033C6.54018 13.3968 5.75 11.4891 5.75 9.5M20.75 9.5V2C20.75 1.66848 20.6183 1.35054 20.3839 1.11612C20.1495 0.881696 19.8315 0.75 19.5 0.75H7C6.66848 0.75 6.35054 0.881696 6.11612 1.11612C5.8817 1.35054 5.75 1.66848 5.75 2V9.5M3.25 25.75H23.25M5.75 9.5H3.875C3.0462 9.5 2.25134 9.17076 1.66529 8.58471C1.07924 7.99866 0.75 7.2038 0.75 6.375C0.75 5.5462 1.07924 4.75134 1.66529 4.16529C2.25134 3.57924 3.0462 3.25 3.875 3.25H5.75",
    stroke: "#147B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramCertification);
export default __webpack_public_path__ + "static/media/ProgramCertification.5f000aa927af33090d236df98a69c55b.svg";
export { ForwardRef as ReactComponent };